import type { PipeTransform } from '@angular/core';
import { Pipe, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'onyxPluralTranslate',
})
export class OnyxPluralTranslatePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  public transform(key: string, number: number): string {
    const language =
      this.translateService.getCurrentLang() ??
      this.translateService.getFallbackLang() ??
      undefined;

    const category = new Intl.PluralRules(language).select(number);
    return `${key}.${category === 'other' ? 'many' : category}`;
  }
}
